/**
 * Constantes de paginação e tamanhos de listagens.
 * Centraliza todos os "magic numbers" usados em page sizes, fetch sizes, etc.
 */

/** Itens por página padrão para tabelas */
export const DEFAULT_PAGE_SIZE = 10;

/** Tamanho de página para fetch de dados em selects/dropdowns */
export const DROPDOWN_LOAD_SIZE = 50;

/** Tamanho de página para fetch de listagens completas (ex: roles, permissions) */
export const MAX_FETCH_ALL_SIZE = 1000;

/** Tamanho de página intermediário para listagens médias */
export const MEDIUM_PAGE_SIZE = 20;

/** Tamanho de página grande para listagens auxiliares */
export const LARGE_PAGE_SIZE = 100;

/** Opções de itens por página disponíveis nas tabelas */
export const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const;

/** Quantidade de passos por página em visualizações de projeto */
export const STEPS_PER_PAGE = 10;
